import React, { useState, useEffect } from "react";
import bem from 'utils/bem';
import { Formik } from 'formik';
import toast from 'react-hot-toast';
import { defaultCart } from 'utils/cart';
import { writeStorage } from '@rehooks/local-storage';
import validationSchema from './validationSchema';
import Form from './Form';
import Model from '../../../../model';
import './index.sass'
import { createBuy } from 'api/items';


const defaultValues = {
    customerPhone: '',
    customerName: '',
    customerSurname: '',
    customerEmail: '',
    customerBirthday: '',
    comment: '',
    paymentSystem: 'A',
    acceptConditions: false,
    city: '',
    country: '',
    region: '',
    index: '',
    address: '',
    delivery: 'pickup_msk',
    password: '',
    cdekDeliveryType: null,
    saleSum: 0,
    sum: 0,
    paymentMethod: 'balance',
    price: '0'
};

const { block, el } = bem('checkout-form');

const CheckoutForm = ({ price, items, openPickupInfo }) => {
    const [initialValues, setInitialValues] = useState(defaultValues);

    useEffect(() => {
        if (items.length === 0) {
            toast.error( `К сожалению, покупка в данный момент недоступна. Пожалуйста, обратитесь к администратору`);
        }
    }, [items])

    const prepareItems = (items) => {
        const result = {};
        items.forEach(item => {
            result[item.id] = item.cartAmount
        })
        return result;
    }

    const handleSubmit = async (values, bag) => {
        const delivery = {
            delivery: values.delivery,
            oldAddress: '',
            country: values.country,
            region: values?.region,
            index: values?.index,
            address: values?.address,
            city: values?.city
        }

        const variables = {
            ...values,
            ...delivery,
            items: JSON.stringify(prepareItems(items)),
        };

        try {
            const { error, paymentStatus, payUrl } = await createBuy(variables);
            Model.user.updateUserInfo();
            if (error) {
                throw error;
            }
            if (paymentStatus === 'A_1' && !payUrl) {
                writeStorage('oc', defaultCart);
                bag.resetForm();
                Model.modal.openCheckoutFormSuccess();
                return;
            }
            if (payUrl) {
                writeStorage('oc', defaultCart);
                window.location.href = payUrl;
            } else {
                throw 'payUrl is null';
            }
        } catch (err) {
            console.log(err);
            toast.error(`Произошла ошибка: ${ err }`);
            bag.setSubmitting(false);
        }
    };

    const rForm = (form) => {
        return <Form
            form={ form }
            price={ price }
            cartItems={ items }
            openPickupInfo={ openPickupInfo }
        />
    }

    return <div className={ block() }>
        <Formik
            initialValues={ initialValues }
            validateOnChange={ false }
            validateOnBlur={ false }
            validationSchema={ validationSchema }
            onSubmit={ handleSubmit }
            enableReinitialize={ false }>
            { form => rForm(form) }
        </Formik>
    </div>
};

export default CheckoutForm;
